import * as React from "react";
import { Route, Routes } from "react-router-dom";
import { useCurrentStudyConfigurationContext } from "../../Core/CurrentStudyConfigurationContext";
import { useSecurityContext } from "../../Core/SecurityContext";
import { PermissionEnum } from "../../misc/api/ApiPermissionEnum";
import { Authorization } from "../../misc/components/Authorization";
import { AlignPermissionsToRole } from "./AlignPermissionsToRole";
import { AlignRoles } from "./AlignRoles";
import { CreateRole } from "./CreateRole";
import { RoleManagementSummary } from "./RoleManagementSummary";

export const RolesRoot = () => {
    const { currentUserPermissions } = useSecurityContext();
    const { study } = useCurrentStudyConfigurationContext();

    return (
        <React.StrictMode>
            <Authorization currentPermissions={currentUserPermissions} studyId={study.id} permissionId={PermissionEnum.ViewRoleManagement}>
            <Routes>
                <Route index element={<RoleManagementSummary/>} />
                <Route path="Create" element={<CreateRole/>} />
                <Route path="Permissions/:id" element={<AlignPermissionsToRole/>} />
                <Route path="Roles/:id" element={<AlignRoles/>} />
            </Routes>
            </Authorization>
        </React.StrictMode>
    );
}
